<div class="py-1 flex flex-col items-center justify-center m-auto h-full w-full relative">
  @if (inputImage() && !imageUrl) {
    <!-- <img src="{{ imageUrl }}" alt="logo" style="height: 60%" /> -->
    <img
      xemexFetchImage
      [src]="inputImage()"
      [dummySrc]="'assets/images/empty/document.svg'"
      alt="logo"
    />
    <div class="absolute -bottom-2 -right-2 h-10 z-10">
      <button
        class="!bg-primary-hover"
        mat-icon-button
        color="primary"
        type="button"
        (click)="fileSelect.click()"
      >
        <mat-icon class="text-primary mb-2">upgrade</mat-icon>
      </button>
    </div>
  } @else if (imageUrl) {
    <!-- <img src="{{ imageUrl }}" alt="logo" style="height: 60%" /> -->
    <img class="max-w-full max-h-full" [src]="imageUrl" alt="logo" />
    <div class="absolute -bottom-2 -right-2 h-10 z-10">
      <button
        class="!bg-primary-hover"
        mat-icon-button
        color="primary"
        type="button"
        (click)="fileSelect.click()"
      >
        <mat-icon class="text-primary mb-2">upgrade</mat-icon>
      </button>
    </div>
  } @else {
    <mat-icon class="text-primary text-[48px] !h-[48px] !w-[48px] mb-1">cloud_upload</mat-icon>
    <button mat-button type="button" class="mt-2 text-sm" (click)="fileSelect.click()">
      {{ 'creation.step1.browserUpload' | translate }}
    </button>
  }

  <!-- <div class="text-md text-primary mb-1">
    {{ 'creation.step1.dragAndDrop' | translate }}
  </div>
  <div class="text-sm text-primary">
    {{ 'creation.step1.or' | translate }}
  </div> -->
  <!-- <div class="text-body font-light text-primary">
    {{ descriptionKey | translate }}
  </div> -->
  <input
    type="file"
    accept="{{ acceptedTypes.join(', ') }}"
    (change)="onFileSelected($event)"
    #fileSelect
    [hidden]="true"
  />
</div>
